/**
 * Converts an area in square meters to hectares, ares, and centiares.
 * @param {number} area - The area in square meters.
 * @returns {string} The area in hectares, ares, and centiares.
 */
export function getAreaAsHectares(area) {
  if (!area) {
    return '';
  }
  const roundarea = area.toFixed(0);
  const ha = Math.floor(roundarea / 10000.0);
  let a = Math.floor((roundarea - ha * 10000.0) / 100.0);
  a = a < 10 ? `0${a}` : a;
  let ca = Math.floor(roundarea % 100.0);
  ca = ca < 10 ? `0${ca}` : ca;
  return `${ha} ha ${a} a ${ca} ca`;
}

/**
 * Formats a length in meters to kilometers if it's more than 1000 meters.
 * @param {number} length - The length in meters.
 * @returns {string} The length in kilometers (if more than 1000m) or meters.
 */
export const getFormattedLength = (length) => {
  return length > 1000 ? `${Math.round((length / 1000) * 1000) / 1000} km` : `${Math.round(length)} m`;
};

/**
 * Formats an area in square meters to hectares if it's more than 1000 square meters.
 * @param {number} area - The area in square meters.
 * @returns {string} The area in hectares (if more than 1000m²) or square meters.
 */
export const getFormattedArea = (area) => {
  return area > 1000 ? `${Math.round((area / 10000) * 10000) / 10000} ha` : `${Math.round(area)} m²`;
};
